import { colors } from "@material-ui/core";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "@/destinations/configs/shared/ConfigPageRow";

export function BaseConfigurationModal({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["adAccountID"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
}

export function BaseConfigurationRow({ setConfigModalOpen, existingConfig }) {
  const settings = existingConfig.settings || {};
  const isValid = "adAccountID" in settings;

  return (
    <DestinationConfigRow
      name="Ad Account ID"
      textColor={isValid ? "" : colors.red[600]}
      labelText={isValid ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
}
